import {useEffect, useRef, useState} from "react";
import {formatFileSize} from "../../../utils/utils";
import TorrentDownloadItem from "./torrentDownloadItem/torrentDownloadItem";
import {fetchTorrestreamItems,} from "../api/cap17drive-api";
import auth from "../../../utils/authentication";
import {useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import Cap17driveHeader from "../cap17driveIndex/cap17driveHeader/cap17driveHeader";
import TorrentDownloadsTable from "./torrentDownloadsTable/torrentDownloadsTable";
import TorrestreamItemsRow from "../squadflixHome/rows/TorrestreamItemsRow";
import {TorresstreamApi} from "../../../apis/torrestream-api/torresstream-api";

const TorrentsDashboard = ({onWidthChange}) => {

    const navigate = useNavigate();
    const intl = useIntl();
    const [torrents, setTorrents] = useState([]);
    const torrentsRef = useRef([]);
    const [torrestreamItems, setTorrestreamItems] = useState([]);
    const lastUpdateTime = useRef(0);
    const [deleting, setDeleting] = useState(false);
    const [torrentsFiles, setTorrentsFiles] = useState([]);

    const handleDeleteTorrent = (torrentId) => {
        TorresstreamApi.get("removeTorrent").call({torrentId}).then(() => {
            setTorrents(prevTorrents => prevTorrents.filter(torrent => torrent.id !== torrentId));
            torrentsRef.current = torrentsRef.current.filter(torrent => torrent.id !== torrentId);
            onWidthChange?.();
        })
    }


    useEffect(() => {

        lastUpdateTime.current = Date.now();

        const fetchStatus = () => {
            TorresstreamApi.getAllDownloadsStatus().then(res => {
                if (res.length !== torrentsRef.current.length || res.some(x => torrentsRef.current.some(y => x.id !== x.id))) {
                    onWidthChange?.();
                }

                const timeTook = Date.now() - lastUpdateTime.current;

                setTorrents(res.map(torrent => {
                    const lastDownloaded = torrentsRef.current.find(x => x.id === torrent.id)?.downloaded_size ?? torrent.downloaded_size;

                    const sizeDownloaded = torrent.downloaded_size - lastDownloaded;
                    const downloadSpeed = sizeDownloaded / timeTook * 1000;

                    return {
                        ...torrent,
                        downloadSpeed: formatFileSize(downloadSpeed) + "/s",
                    }
                }));

                torrentsRef.current = res;


                lastUpdateTime.current = Date.now();
            });
        }

        fetchStatus();

        const updateInterval = setInterval(() => {
            fetchStatus();
        }, 2000);

        return () => {
            clearInterval(updateInterval);
        }
    }, []);

    useEffect(() => {
        const getTorrestreamItems = async () => {
            const items = await fetchTorrestreamItems(auth.currentUser.uid);
            setTorrestreamItems(items.items);
        }
        const getTorrentFiles = async () => {
            const items = await TorresstreamApi.get("getAllDonwloadedTorrents").call();
            setTorrentsFiles(items);
        }

        const getAll = async () => {
            await Promise.all([getTorrestreamItems(), getTorrentFiles()]);
        }

        getAll().then(() => {
            onWidthChange?.();
        });

    }, []);

    return (
        <div>
            <Cap17driveHeader/>

            {/* Lista de torrents en progreso */}
            {torrents.map(torrent => (
                <TorrentDownloadItem
                    key={torrent.id}
                    torrent={torrent}
                    onRemoveTorrent={() => {
                        if (deleting) {
                            return;
                        }
                        setDeleting(true);
                        handleDeleteTorrent(torrent.id);
                    }}/>
            ))}

            <hr/>

            <TorrestreamItemsRow intl={intl}/>

            <hr/>

            <TorrentDownloadsTable torrentsFiles={torrentsFiles}/>
        </div>
    );
}

export default TorrentsDashboard;
